import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { sanitizeThemeStyleByNumber } from '../../helpers/style';

export const FlexDiv = styled.div`
  display: flex;
  ${props =>
    props.backgroundColor
      ? `background-color: ${props.backgroundColor}`
      : null};
  ${props =>
    props.borderRadius ? `border-radius: ${props.borderRadius}` : null};
  ${props => (props.ai ? `align-items: ${props.ai}` : null)};
  ${props => (props.jc ? `justify-content: ${props.jc}` : null)};
  ${props => (props.ac ? `align-content: ${props.ac}` : null)};
  ${props => (props.flexDir ? `flex-direction: ${props.flexDir}` : null)};
  ${props => (props.flexWrap ? `flex-wrap: ${props.flexWrap}` : null)};
  ${props => (props.flexFlow ? `flex-flow: ${props.flexFlow}` : null)};
  ${props => (props.margin ? `margin: ${props.margin}` : null)};
  ${props => (props.padding ? `padding: ${props.padding}` : null)};
  ${props => (props.gap ? `gap: ${props.gap}` : null)};
  ${props =>
    props.width
      ? `width: ${
          !Number.isNaN(Number(props.width)) ? `${props.width}px` : props.width
        }`
      : null};
  ${props =>
    props.height
      ? `height: ${
          !Number.isNaN(Number(props.height))
            ? `${props.height}px`
            : props.height
        }`
      : null};
  ${props => (props.opacity ? `opacity: ${props.opacity}` : null)};
  ${props =>
    props.paddingBottom ? `padding-bottom: ${props.paddingBottom}` : null};

  ${props => (props.gapRow ? `row-gap: ${props.gapRow}` : null)};
  ${props => (props.gapColumn ? `column-gap: ${props.gapColumn}` : null)};
  ${props =>
    props.borderBottom ? `border-bottom: ${props.borderBottom}` : null};
  & .mr-grow {
    flex-grow: 1;
  }
`;

const MFlexbox = forwardRef(({ width, height, ...rest }, ref) => (
  <FlexDiv
    ref={ref}
    width={sanitizeThemeStyleByNumber(width)}
    height={sanitizeThemeStyleByNumber(height)}
    {...rest}
  />
));

export default MFlexbox;
